import { observable, computed, makeObservable } from 'mobx'
import PageQuestion from './Models/PageQuestion'
import SkipLogic from './Models/SkipLogic'

const setter = (target, name, descriptor) => {
    const privateName = `_${name}`;
    observable(target, privateName, descriptor);
    return computed(target, name, {
      get() {
        return this[privateName];
      },
      set(value) {
        console.log('hah setter')
        this[privateName] = value;
      }
    });
  };

const List = (className) => {
    return (target, name, descriptor) => {
        const privateName = `_${name}`
        observable(target, privateName, descriptor)
        return computed(target, name, {
            get() {
                console.log(`getting page questions ${this[privateName].length}`)
              return this[privateName];
            },
            set(arr) {
                console.log(`List ${arr}`)
                const list = []
                const that = this
                arr.forEach((question) => {
                    console.log(`instanceof ${(question instanceof className)}`)
                    let dquestion
                    if (question instanceof className) {
                        dquestion = question
                    } else {
                        dquestion = new className(question, this.store, this.survey)
                    }

                    list.push(dquestion)
                })
                this[privateName] = list
            }
        })
    }
}

export default class Page {
    id = 0
    pageType = ""
    priority = 1
    // @observable questions = []
    @List(PageQuestion) questions
    @observable skipLogic = []
    @observable skipPagetoPageRules = observable.map({})
    @observable skipToPageLogic
    @observable pagerouting = { label: "", value: "" }
    title = ""
    @setter randomize = false
    questionId = 0
    content = ""
    skipToPageTarget = []
    @observable redirectUrlSettings = {}

    constructor(page, store, survey) {
        makeObservable(this)
        this.store = store
        this.survey = survey

        this.id = page.id
        this.pageType = page.pageType
        this.priority = page.priority
        this.title = page.title
        this.randomize = page.randomize
        this.content = page.content
        this.questions = page.questions || []
        this.redirectUrlSettings = page.redirectUrlSettings

        this.skipToPageLogic = new SkipLogic({
            action: {
                kind: 'SkipToPage',
                pageId: this.id,

            },
            triggerGroups: [
                {
                    children: [
                        {
                            triggers: [
                            ]
                        }
                    ]
                }
            ]
        }, this.store)
    }

    getQuestionOid = (pageQuestion) => {
        const oids = {
            "explori": 1,
            "client": 3,
            "portfolio": 5,
            "product": 6,
            "survey": 7,
        }

        return oids[pageQuestion.questionLevel]
    }

    setPageRouting = (skipLogic, survey) => {
        console.log("setPageRouting")
        const pageId = skipLogic.groups[0].groups[0].rules[0].pageId
        this.pageRoutingId = skipLogic.id

        this.pagerouting = { value: pageId, label: survey.getPageLabelWithIndex(pageId)}
    }

    getQuestion = (questionId) => {
        return this.questions.find((question) => question.questionId === questionId)
    }

    removeSkipToPage = () => {
        console.log('removeSkipToPage')
        this.questions.forEach((question) => {
            question.deleteSkipToPage()
        })
        this.validateSkipToPage()
    }

    validateSkipToPage = () => {
        const that = this
        const page = this
        const pages = this.store.survey.getPageIndexes()
        const currIndex = pages.indexOf(this.id)
        this.questions.forEach((question) => question.validateSkipToPage(this))
        let keysToDelete = []
        console.log(this.id)
        if (Object.hasOwnProperty.call(that.store.skipToPageTarget, page.id)) {
            for (const key of Object.keys(that.store.skipToPageTarget[page.id])) {
                console.log(`test ${key}`)
                let pageQuestion// = that.store.survey.pageQuestions[key]
                for (const pqId in that.store.survey.pageQuestions) {
                    const pq = that.store.survey.pageQuestions[pqId]
                    console.log(`pageQuestion ${pq.id}`)
                    if (pq.id === key) {
                        pageQuestion = pq
                    }
                }
                const pageIndex = pages.indexOf(pageQuestion.page.id)
                console.log(`${pageIndex} > ${currIndex}`)
                if (pageIndex > currIndex) {
                    const logics = that.store.skipToPageTarget[this.id][key]
                    logics.forEach((logic) => {
                        const skipToPage = pageQuestion.skipToPage.get(logic)
                        skipToPage.logic.delete()
                        pageQuestion.skipToPage.delete(logic)
                    })
                    keysToDelete.push(key)
                }
            }
        }
        console.log(`keysToDelete ${keysToDelete}`)
        keysToDelete.forEach((key) => that.store.skipToPageTarget[this.id][key] = [])
    }

    hasSkipToPage = () => {
        // console.log('hasSkipToPage')
        // const hasLogic = this.questions.reduce((hasLogic, question) => (hasLogic || question.skipToPage.size > 0), false)
        // console.log(hasLogic)
        // return hasLogic
        return this.questions.some(pageQuestion => pageQuestion.hasSkipToPageLogic)
    }

    getIndex = () => {
        const {survey} = this.store
        console.log(`getIndex ${this.id}`)
        return survey.getPageIndex(this)
    }

    setSkipToPage = (logic, targetPage) => {
        const {survey} = this.store
        this.skipToPageLogic.id = logic.id
        this.skipToPageLogic.skipToPageTarget = { label: "Page: " + survey.getPageIndex(targetPage) + (targetPage.title ? ( " - " + targetPage.title) : ""), value: targetPage.id }
        this.skipToPageLogic.action.pageId = this.id
        console.log(`setSkipToPage ${JSON.stringify(this.skipToPageLogic.skipToPageTarget)}`)
    }

    update = () => {
        const that = this
        console.log("update " + this.survey.id + " " + this.id)
        const endpoint = "/api/survey/" + this.survey.id + "/page/" + this.id
        const body = JSON.stringify({
            randomize: that.randomize,
            title: that.title,
        })
        that.store.http.put(endpoint, body)
            .then((res) => {
                console.log("done " + res)
                this.store.addNotification(null, "Page updated", "success")
            }).catch((e) => {
                console.log(e)
                this.store.addNotification(null, "Error updating page: " + e.message, "error")
            })
    }

    removeQuestion = (question, index, survey, soft) => {
        const that = this
        let new_arr = []
        that.questions.forEach((question) => {
            new_arr.push(question)
        })
        const questionBackup = that.questions
        new_arr.splice(index, 1)
        that.questions = new_arr

        console.log("removeQuestion " + index + " from page " + that.id)
        const endpoint = "/api/survey/" + that.survey.id + "/page/" + that.id + "/pageQuestion/" + question.id
        // question.status = 'deleted'
        // console.log(`pageQuestion status ${question.id} = ${question.status} `)
        if (!soft) {
            that.store.http.delete(endpoint)
                .then((res) => {
                    console.log("done " + res)
                    survey.num_questions -= 1
                    question.status = 'deleted'
                    delete survey.pageQuestions[question.id]
                    // this.survey.skipLogic.forEach(sl => sl.pageQuestionRemoved(question.id))
                    that.store.addNotification(null, "Question deleted", "success")
                    that.store.survey.refreshSkipLogic(store, false)
                }).catch((e) => {
                    console.log(e)
                    that.store.addNotification(null, "Failed to delete question: " + e.message, "error")
                    that.questions = questionBackup
                })
        }
    }

    updateQuestion = (question, jsonBody) => {
        const that = this
        // console.log("updateQuestion " + question.id + " on page " + that.id)
        // let body
        // if (!jsonBody) {
        //     body = {
        //         mandatory: question.mandatory,
        //         isLocked: question.isLocked,
        //     }

        //     if (question.inheritQuestion.value !== "") {
        //         body.parentId = question.inheritQuestion.value
        //     } else {
        //         body.parentId = "00000000-0000-0000-0000-000000000000"
        //     }
        // } else {
        //     body = jsonBody
        // }

        // const endpoint = "/api/survey/" + that.survey.id + "/pageQuestion/" + question.id
        // that.store.http.put(endpoint, JSON.stringify(body))
        //     .then((res) => {
        //         console.log("done " + res)
        //         this.store.addNotification(null, "Question updated", "success")
        //     }).catch((e) => {
        //         console.log(e)
        //         this.store.addNotification(null, "Error updating question: " + e.message, "error")
        //     })
    }

    moveQuestion = (question, new_index, pageId) => {
        const that = this
        console.log("moving question " + question.id + " to index " + new_index)
        const questionBackup = that.questions
        that.questions.splice((new_index-1), 0, question)
        // that.questions = new_arr
        const id = pageId || this.id
        const endpoint = "/api/survey/" + that.survey.id + "/page/" + id + "/pageQuestion/" + question.id + "/move"
        const body = JSON.stringify({
            toPageId : that.id,
            toPos : new_index
        })
        that.store.http.put(endpoint, body)
            .then((res) => {
                console.log("done " + res)
                that.store.addNotification(null, "Question moved", "success")
            }).catch((e) => {
                console.log(e)
                that.store.addNotification(null, "Failed to move question: " + e.message, "error")
                that.questions = questionBackup
            })
    }

    addQuestion = (question, history, survey, same_page, position) => {
        console.log("add question " + question.questionId + " to page " + this.id)
        console.log(this.store)
        console.log(this.store.http)
        const that = this
        const pos = (typeof position === "number") ? (position + 1) : this.questions.length + 1
        const questionBackup = this.questions.slice()

        let level = "survey"
        if (question.oid === 1) {
            level = "explori"
        } else if (question.oid === 3) {
            level = "client"
        }

        if (typeof position === "number") {
            // const temp = this.questions.slice()
            console.log(`question is ${question} ${question instanceof PageQuestion}`)
            if (!(question instanceof PageQuestion)) {
                console.log('not a pageQuestion')
                question = new PageQuestion({
                    questionId: question.questionId,
                    priority: pos,
                    questionLevel:level,
                    mandatory: question.mandatory
                }, that.store, that.survey)
            }
            this.questions.splice(position, 0, question)
            // this.questions = observable(temp)
        }

        const endpoint = "/api/survey/" + that.survey.id + "/page/" + that.id + "/pageQuestion"
        const body = JSON.stringify({
            questionIdReference: question.questionId,
            atPos: pos,
            mandatory: true,
            questionLevel: level,
            parentId: question.inheritQuestion.value || "00000000-0000-0000-0000-000000000000"
        })

        that.store.http.post(endpoint, body)
            .then((res) => {
                console.log("added question to page " + JSON.stringify(res, null, 4))
                console.log(position + ", " + (typeof position))
                // question.host = that.store.gateway
                // question.title = question.title || question.langs.get(survey.primarylanguage.value).T.text
                // question.id = res.newPageQuestionId
                // question.oid = 7
                if ((typeof position !== "number")) {
                    console.log("PUSHING")
                    // that.questions = that.questions.concat(question)
                    const pageQuestion = new PageQuestion({
                        id: res.newPageQuestionId,
                        questionId: question.questionId,
                        priority: pos,
                        questionLevel: body.questionLevel,
                        parentId: body.parentId,
                    }, that.store, that.survey)
                    survey.pageQuestions[pageQuestion.id] = question
                    that.questions.push(pageQuestion)
                } else if (res.newPageQuestionId) {
                    question.id = res.newPageQuestionId
                }
                survey.num_questions += 1
                survey.store.addNotification(null, "Question added to page", "success")
                // question.populate(question.questionId, survey)
            }).catch((e) => {
                console.log(e)
                survey.store.addNotification(null, "Error adding question to page: " + e.message, "error")
                this.questions = questionBackup
            })
    }

    updateContent = (lang_code = "en_GB") => {
        return new Promise((resolve, reject) => {
            const that = this
            const endpoint = "/api/survey/" + this.survey.id + "/page/" + this.id + "/content"
            const body = JSON.stringify({
                langcode: lang_code,
                text: that.content[lang_code].text,
            })
            that.store.http.put(endpoint, body)
                .then(resolve)
                .catch(reject)
        })
    }
}
